._container_1gqb3_1 {
  position: relative;
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #2980F2;
  overflow: hidden;
  animation: _breathContainer_1gqb3_1 0.9s infinite alternate-reverse ease-in-out; }
  [data-theme="chat-theme-dark"] ._container_1gqb3_1 {
    background: #AEFF84; }

@container chat (max-width: 470px) {
  ._container_1gqb3_1 {
    width: 18px;
    height: 18px; } }

._inner_1gqb3_19 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  width: 100%;
  height: 100%;
  animation: _breathInner_1gqb3_1 0.9s infinite alternate ease-in-out;
  background: #5ff2ae;
  filter: blur(6px); }
  [data-theme="chat-theme-dark"] ._inner_1gqb3_19 {
    background: transparent; }

@container chat (max-width: 470px) {
  ._inner_1gqb3_19 {
    filter: blur(6px); } }

@keyframes _breathContainer_1gqb3_1 {
  to {
    transform: scale(0.8); } }

@keyframes _breathInner_1gqb3_1 {
  from {
    transform: translate(-50%, -50%) scale(0.3); }
  to {
    transform: translate(-50%, -50%) scale(0.4); } }
